<template>
  <div>
    <PageTitle :title="$t('navigation.refer-a-friend')" />
    <Card :disable-title="true">
      <div class="refer-a-friend-centered">
        <div class="refer-a-friend-messsages mb-2">
          <div class="refer-a-friend-message-bold mb-4">
            {{ $t("navigation.refer-a-friend-title") }}
          </div>
        </div>
        <div class="refer-a-friend-submessage mb-4">
          {{ $t("navigation.refer-a-friend-message") }}
        </div>
        <div class="mb-4">
          <template>
            <svg xmlns="http://www.w3.org/2000/svg" width="109" height="104" viewBox="0 0 109 104">
              <g :fill="svgColorComputed">
                <path
                  d="M29.75 65.665c1.195-.69 1.605-2.22.915-3.415-.69-1.195-2.22-1.605-3.415-.915-1.195.69-1.605 2.22-.915 3.415.69 1.195 2.22 1.605 3.415.915z"
                />
                <path
                  d="M20.69 81.028l10.854 18.687c2.342 4.036 7.612 5.53 11.779 3.137 4.123-2.368 5.54-7.604 3.155-11.706L40.01 80.013l5.6-3.213c1.03-.592 1.384-1.902.79-2.926l-2.804-4.825L84.883 61c4.79-.258 7.661-5.466 5.241-9.629L82.961 39.04l4.578-6.891c.45-.678.476-1.55.068-2.252l-4.311-7.421c-.409-.703-1.184-1.115-1.997-1.067l-8.292.495-7.953-13.69C63.902 6.23 61.84 5.028 59.535 5h-.082c-2.227 0-4.247 1.101-5.445 2.963l-28.157 35.65L7.545 54.117c-7.2 4.13-9.694 13.31-5.523 20.484 3.811 6.56 11.845 9.141 18.667 6.427zm22.055 12.261c1.19 2.047.486 4.667-1.58 5.852-2.072 1.191-4.71.46-5.888-1.568L24.5 79.018l7.467-4.284 10.778 18.555zm-4.89-16.987l-2.155-3.71 3.733-2.142 2.156 3.71-3.733 2.142zm42.373-50.537l2.98 5.128-2.657 3.998-5.134-8.84 4.811-.286zM57.614 10.312c.578-.94 1.496-1.038 1.868-1.028.368.005 1.285.118 1.838 1.07l25.071 43.16c.817 1.404-.176 3.17-1.814 3.211-.294.007-.43.06-1.182.2l-26.52-45.653c.557-.711.628-.78.739-.96zm-3.607 4.592l24.916 42.892-37.604 7.33-11.434-19.682 24.122-30.54zM5.756 72.459c-.947-1.628-1.447-3.476-1.447-5.345 0-3.82 2.066-7.379 5.391-9.287l16.8-9.64 10.778 18.552-16.8 9.641c-5.147 2.952-11.75 1.193-14.722-3.921z"
                />
                <path
                  d="M22.71 67.071c-.599-1.024-1.923-1.375-2.959-.784L16 68.43c-1.034.59-2.361.238-2.958-.784-.599-1.025-1.923-1.376-2.959-.785-1.035.592-1.39 1.903-.793 2.927 1.783 3.054 5.76 4.131 8.876 2.352l3.75-2.142c1.036-.592 1.392-1.901.794-2.927zM105.86 9.273l-11.774 6.686c-1.02.58-1.387 1.892-.819 2.933.566 1.039 1.852 1.416 2.874.835l11.773-6.686c1.02-.58 1.387-1.892.819-2.933-.567-1.04-1.854-1.415-2.873-.835zM104.482 31.114l-7.905-2.046c-1.092-.283-2.214.343-2.507 1.397-.292 1.055.356 2.138 1.448 2.42l7.906 2.047c1.098.285 2.215-.35 2.506-1.398.292-1.054-.356-2.138-1.448-2.42zM83.115 1.643l-2.047 8.566c-.283 1.182.343 2.397 1.397 2.715 1.053.316 2.137-.383 2.42-1.567l2.047-8.565c.283-1.183-.343-2.399-1.397-2.716-1.053-.317-2.137.385-2.42 1.567z"
                />
              </g>
            </svg>
          </template>
        </div>
        <div class="d-inline-flex justify-content-center flex-wrap mb-4">
          <div class="font-weight-bold mr-2">{{ $t("navigation.refer-a-friend-share") }}:</div>
          <div class="mr-2 link">{{ referLink }}</div>
          <div><CopyToClipboard :text="referLink" /></div>
        </div>
        <div>
          {{ $t("navigation.refer-a-friend-questions") }}
          <a :href="`mailto:` + referEmail"> {{ referEmail }}</a
          >.
          {{ $t("navigation.refer-a-friend-learn-more") }}
          <a
            href="https://help.nexcess.net/refer-a-friend"
            target="_blank"
            rel="noopener noreferrer"
            >here</a
          >.
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/display/Card";
import { computed } from "@vue/composition-api";
import CopyToClipboard from "@/components/display/CopyToClipboard";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";
import { useTheme } from "@/utils/index";

export default {
  name: "ReferAFriendPage",
  components: { Card, CopyToClipboard, PageTitle },
  setup() {
    const { theme } = useTheme();

    const client = computed(() => store.getters["auth/getClient"]);

    const svgColorComputed = computed(() => {
      return theme.value?.iconColors?.omicron;
    });

    const referLink = computed(() => {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/refer-a-friend/" +
        client.value.id
      );
    });

    const referEmail = "referafriend@nexcess.net";

    return { client, referEmail, referLink, svgColorComputed };
  },
};
</script>
<style lang="scss" scoped>
.refer-a-friend-centered {
  text-align: center;
  margin-top: 2.5rem;
  margin-bottom: 2.125rem;

  .refer-a-friend-messages {
    display: flex;
    justify-content: center;
    word-wrap: break-word;
  }
  .refer-a-friend-message-bold {
    font-size: 1.875rem;
    line-height: 0.93;
  }
  .refer-a-friend-message-bold {
    font-weight: bold;
  }
  .refer-a-friend-submessage {
    font-size: 1.0625rem;
    line-height: 1.53;
  }

  .link {
    text-decoration: underline;
  }
}
</style>
